import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaSignOutAlt } from "react-icons/fa";
import "./HeaderLanding.css";
import { logoutUser } from "../../../redux/slice/authSlice/UserSlice.js";
import { useDispatch } from "react-redux";
import { logo } from "../../../../assets/index.js";

const HeaderLanding = () => {
  const dispatch = useDispatch();

  const [isDarkMode, setIsDarkMode] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [scrollPos, setScrollPos] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const savedDarkMode = localStorage.getItem("darkMode");
    if (savedDarkMode === "true") {
      setIsDarkMode(true);
      document.body.classList.add("dark-mode");
    }

    const token = localStorage.getItem("userToken");
    setIsLoggedIn(!!token);

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setShowHeader(scrollPos > currentScrollPos || currentScrollPos < 10);
      setScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollPos]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    document.body.classList.toggle("dark-mode", !isDarkMode);

    // Save the dark mode preference in localStorage
    localStorage.setItem("darkMode", !isDarkMode);
  };

  const handleLogout = async () => {
    const token = localStorage.getItem("userToken");
    if (token) {
      await dispatch(logoutUser());
      navigate("/login");
    } else {
      navigate("/login");
    }
  };

  return (
    <Navbar
      bg="light"
      expand="lg"
      sticky="top"
      className={`header-navbar background-dark ${
        showHeader ? "show" : "hide"
      }`}
    >
      <Container>
        <Navbar.Brand
          href="#"
          className="fw-bold text-primary fs-4 fw-bolder test-info "
        >
          <img src={logo} alt="" className="header-logo " />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar" className="button-all" />

        <Navbar.Collapse id="navbar" className="landing-text-white">
          <Nav className="mx-auto">
            <Nav.Link
              href="#about"
              className="ps-4 fs-6 pe-4 landing-text-white"
            >
              About
            </Nav.Link>
            <Nav.Link
              href="#features"
              className="ps-4 fs-6 pe-4 landing-text-white"
            >
              Features
            </Nav.Link>
            <Nav.Link
              href="#prices"
              className="ps-4 fs-6 pe-4 landing-text-white"
            >
              Price
            </Nav.Link>
            <Nav.Link
              href="#testimonials"
              className="ps-4 fs-6 pe-4 landing-text-white"
            >
              Testimonials
            </Nav.Link>
            <Nav.Link
              href="#contact"
              className="ps-4 fs-6 pe-4 landing-text-white"
            >
              Contact
            </Nav.Link>
            <Nav.Link onClick={toggleDarkMode}>
              <span
                className={`ms-3 me-2 p-2 rounded-3 button-all ${
                  isDarkMode ? "text-white" : "text-dark"
                }`}
              >
                {isDarkMode ? "Light " : "Dark "}
              </span>
            </Nav.Link>
          </Nav>

          <Nav>
            {!isLoggedIn ? (
              <>
                <div>
                  <Link to="/login">
                    <Button variant="" className="me-2 login-icon py-2">
                      <FaUser /> Login
                    </Button>
                  </Link>
                </div>
                <div>
                  <Link to="/register">
                    <Button variant="primary py-2">
                      <FaLock /> Signup
                    </Button>
                  </Link>
                </div>
              </>
            ) : (
              <div>
                <Button
                  variant="danger"
                  className="me-2 py-2"
                  onClick={handleLogout}
                >
                  <FaSignOutAlt /> Logout
                </Button>
              </div>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default HeaderLanding;
